module.exports = __webpack_public_path__ + "media/images/buddy-3c680d9f29d5cb4edab864ab4a911e53.png";